
  (function() {
    class FeaturedProductarw9vb212shjqb21tmaigenblockdc6daffwh9jtk extends HTMLElement {
      constructor() {
        super();
      }
    }
    customElements.define('featured-product-arw9vb212shjqb21tmaigenblockdc6daffwh9jtk', FeaturedProductarw9vb212shjqb21tmaigenblockdc6daffwh9jtk);
  })();


  (function() {
    class AiStepsasnzvuxr2oulmvmc0daigenblock7e9934erz6dea extends HTMLElement {
      constructor() {
        super();
      }
    }
    customElements.define('ai-steps-asnzvuxr2oulmvmc0daigenblock7e9934erz6dea', AiStepsasnzvuxr2oulmvmc0daigenblock7e9934erz6dea);
  })();


  (function() {
    class MobileHeroaduzlu3hrmlbxbzrvmaigenblockd5d68decqrzvl extends HTMLElement {
      constructor() {
        super();
      }
    }
    customElements.define('mobile-hero-aduzlu3hrmlbxbzrvmaigenblockd5d68decqrzvl', MobileHeroaduzlu3hrmlbxbzrvmaigenblockd5d68decqrzvl);
  })();


  (function() {
    class ComparisonSectionaaklxa1ppu0jpsnd6raigenblock6ab046ayqnxx8 extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.style.display = 'block';
      }
    }

    customElements.define('comparison-section-aaklxa1ppu0jpsnd6raigenblock6ab046ayqnxx8', ComparisonSectionaaklxa1ppu0jpsnd6raigenblock6ab046ayqnxx8);
  })();


  (function() {
    class TimelineBlockakzi5m3hauliyatdpraigenblock9cfb2b7qftatz extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.adjustMarkerSpacing();
        window.addEventListener('resize', () => this.adjustMarkerSpacing());
      }

      adjustMarkerSpacing() {
        const cards = this.querySelectorAll('.ai-timeline-card-akzi5m3hauliyatdpraigenblock9cfb2b7qftatz');
        const markers = this.querySelectorAll('.ai-timeline-marker-akzi5m3hauliyatdpraigenblock9cfb2b7qftatz');
        const markersContainer = this.querySelector('.ai-timeline-markers-akzi5m3hauliyatdpraigenblock9cfb2b7qftatz');

        if (!cards.length || !markers.length || !markersContainer) return;

        let totalHeight = 0;
        cards.forEach(card => {
          totalHeight += card.offsetHeight;
        });

        const gap = 24;
        totalHeight += gap * (cards.length - 1);

        markersContainer.style.height = totalHeight + 'px';
      }
    }

    customElements.define('timeline-block-akzi5m3hauliyatdpraigenblock9cfb2b7qftatz', TimelineBlockakzi5m3hauliyatdpraigenblock9cfb2b7qftatz);
  })();

document.addEventListener('click',function(e){const a=e.target.closest('a[href="#rz-order"]');if(a){e.preventDefault();const trigger=document.getElementById('es-popup-button');if(trigger){trigger.click();return;}const el=document.getElementById('rz-order');if(el)el.scrollIntoView({behavior:'smooth'});}});